import * as React from 'react';

import * as PropTypes from 'prop-types';
import { matchPath } from 'react-router';

import DropdownMenu from '../../components/DropdownMenu';
import Header from '../../components/Header';
import MenuItem from '../../components/MenuItem';
import {
    TabContent,
    Tabs,
} from '../../components/Tabs';
import env from '../../env';
import { FeatureFlag } from '../../types';
import SmartListComponent, {
    filterReducer,
    initialFilter,
    initialState,
    listReducer,
} from '../SmartList';

const ConversationListPlaceholder: React.StatelessComponent<{ session: any, onDesktop: boolean }> = ({ session, onDesktop }, { translate }) => {
    const basePath = window.location.pathname.split('/messenger').join('');
    const hasConversationId = Boolean(matchPath(basePath, { path: '/conversation/:conversationId' })) || Boolean(matchPath(basePath, { path: '/log/:conversationId' }));
    const mobileMenu = []; // (conditionally push more elements in to build up a multi-icon menu
    const [selectedTab, setSelectedTab] = React.useState(0);
    const hasSmartList = (session.features && session.features.length > 0) ? session.features.includes(FeatureFlag.SMARTLIST) : false;
    const [state, dispatchState] = React.useReducer(listReducer, initialState);
    let selectedFiltersObj = initialFilter;
    const selectedFilters = sessionStorage.getItem('selectedFiltersStorage');
    if (selectedFilters) {
        selectedFiltersObj = JSON.parse(selectedFilters);
    }
    const [filters, dispatchFilters] = React.useReducer(filterReducer, selectedFiltersObj);
    const handleSwitchTabs = (index: number) => {
        setSelectedTab(index);
    };

    // @todo Include items as Logout, Settings, Edit my profile, etc...
    mobileMenu.push(
        <DropdownMenu
            className="header__button header__settingsMenu settingsMenu"
            name="header__settingsMenu"
            align="left"
            closeOnOutsideClick={true}
            toggleLabel={translate('actions')}
            key="settingsMenu"
        >
            {session.features.includes(FeatureFlag.CRM) &&
                <MenuItem
                    onClickAction={() => (window.location.href = `${env.WEBAPP_HOST}accounts`)}
                    label={translate('launch_statflo_crm')}
                    target="_blank"
                    key="statfloCrm"
                />
            }
        </DropdownMenu>
    );

    const headerRightContent = /* onDesktop */ true ? null : mobileMenu;

    return (
        <>
            <div className="conversationsList__view border-right">
                <Header
                    session={session}
                    title={translate('conversations')}
                    rightContent="renderChildren"
                >
                    {headerRightContent}
                </Header>
                <Tabs translate={translate} onChange={handleSwitchTabs} unread={0}>
                    <TabContent label={translate('inbox')} active enabled>
                        <div className="conversationsList__scroll">
                            <div className="conversationsList__placeholder">
                                <p>{translate('no_open_conversations')}<br />
                                    {translate('start_conversation_account')}</p>
                                <a className="actionButton" href={env.WEBAPP_HOST + 'accounts'}>{translate('view_accounts_convo')}</a>
                            </div>
                        </div>
                    </TabContent>
                    <TabContent label={translate('smart_list')} enabled={hasSmartList}>
                        <SmartListComponent
                            translate={translate}
                            state={state}
                            session={session}
                            dispatchState={dispatchState}
                            dispatchFilters={dispatchFilters}
                            filters={filters}
                        />
                    </TabContent>
                </Tabs>
            </div>
            {
                // render a placeholder where the conversation will be
                !hasConversationId && onDesktop &&
                <div className="flexbox__column">
                    <div className="flexbox__row empty__state">
                        {selectedTab === 0 && <p>{translate('conversation_select_chat')}</p>}
                        {selectedTab === 1 && <p>{translate('conversation_set_filters')}</p>}
                    </div>
                </div>
            }
        </>
    );
};

export default ConversationListPlaceholder;

ConversationListPlaceholder.contextTypes = {
    translate: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/sections/ConversationsList/ConversationsListPlaceholder.tsx